import { LIST_SORT_DEFAULT, sortCategoryTreeSiblings } from './contentListSort';

/**
 * Düz kategori listesinden hiyerarşik ağaç. Kardeş sıra `listSort` ile.
 */
export function buildCategoryTree(categories, listSort = LIST_SORT_DEFAULT) {
  const categoryMap = {};
  const rootCategories = [];

  categories.forEach((category) => {
    const id = category.id || category._id;
    categoryMap[id] = {
      ...category,
      id,
      children: [],
    };
  });

  categories.forEach((category) => {
    const id = category.id || category._id;
    const parentId = category.ustKategoriId;

    if (parentId && categoryMap[parentId]) {
      categoryMap[parentId].children.push(categoryMap[id]);
    } else {
      rootCategories.push(categoryMap[id]);
    }
  });

  sortCategoryTreeSiblings(rootCategories, listSort);
  return rootCategories;
}

/**
 * `ancestorId` düğümü, `nodeId` zincirinde (yukarı doğru) var mı?
 * Kategori taşırken: `nodeId` hedef üst olamaz eğer `ancestorId` kaynak kategori ve
 * kaynak, hedefin üstlerinden biri ise (döngü).
 */
export function isCategoryAncestorOf(ancestorId, nodeId, list) {
  let cur = nodeId;
  let g = 0;
  const anc = String(ancestorId);
  while (cur != null && cur !== '' && g++ < 500) {
    if (String(cur) === anc) return true;
    let row = null;
    for (let i = 0; i < list.length; i++) {
      if (String(list[i].id || list[i]._id) === String(cur)) {
        row = list[i];
        break;
      }
    }
    if (!row) break;
    cur = row.ustKategoriId;
  }
  return false;
}
